import { DISPATCH_SAVE, DISPATCH_CLEAR } from '@/store/types'

export const dispatch = {
  async dispatchSave({ commit, state }, data) {
    commit(DISPATCH_SAVE, data)
  },
  async dispatchClear({ commit, state }) {
    commit(DISPATCH_CLEAR)
  }
}
